/* eslint-disable */

export default {
    0: {
        exceed: '超',
        exceed1: '人关注',
        title1: '分析师点评',
        detail: '详情',
        update: '更新时间',
        timetxt: '24小时内',
        trend: '价格走势',
        money: '成交额',
        top3: 'TOP 3',
        special: '关键数据',
        targetPrice: '分析师目标价',
        price52Txt: '52周最高价',
        total: '成交额',
        inout: '净买入'
    },
    // 繁体版
    1: {
        exceed: '超過',
        exceed1: '人關注',
        title1: '分析師點評',
        detail: '詳情',
        update: '更新時間',
        timetxt: '24小時內',
        trend: '價格走勢',
        money: '成交額',
        top3: 'TOP 3',
        special: '關鍵數據',
        targetPrice: '分析師目標價',
        price52Txt: '52周最高價',
        total: '成交額',
        inout: '淨買入'
    },
    // 英文版
    2: {
        exceed: 'Over',
        exceed1: 'followers',
        title1: 'Analyst Commentary',
        detail: 'Detail',
        update: 'Updated',
        timetxt: '24hour',
        trend: 'Price Trend',
        money: 'Top3',
        top3: 'Trade Volume',
        special: 'Key Data',
        targetPrice: 'Target Price',
        price52Txt: '52wk High',
        total: 'Volume',
        inout: 'Net Flow'
    },
    5: {
        exceed: '', // 日语特殊处理，见index.vue
        exceed1: '', // 日语特殊处理，见index.vue
        title1: '',
        detail: 'Detail',
        timetxt: '24時間前',
        trend: 'チャート',
        money: '出来高',
        top3: 'トップ3',
        special: '注目銘柄',
        targetPrice: 'targetPrice',
        price52Txt: '52週高値',
        total: '売買代金',
        inout: '買越額'
    }
};
